import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=de71dbe8&scoped=true"
import script from "./Info.vue?vue&type=script&lang=ts"
export * from "./Info.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de71dbe8",
  null
  
)

export default component.exports